import { render } from "./FormArbeitsberichte.vue?vue&type=template&id=d36e97ee"
import script from "./FormArbeitsberichte.vue?vue&type=script&lang=js"
export * from "./FormArbeitsberichte.vue?vue&type=script&lang=js"

import exportComponent from "/home/hiro/lab/hands4you-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__